<script setup lang="ts">
import { useDocument } from '@/composition/useDocument'
import { UISpin } from '@gohighlevel/ghl-ui'
import { onMounted, ref } from 'vue'
import PagesLoop from '@/components/editor/PagesLoop.vue'

const pageLoading = ref(false)
const { loading, loadTemplate } = useDocument()

const loadData = async () => {
  await loadTemplate()
}

onMounted(async () => {
  pageLoading.value = true
  await loadData()
  pageLoading.value = false
})
</script>

<template>
  <div
    v-if="pageLoading"
    class="flex justify-center items-center justify-items-center h-screen"
  >
    <UISpin :show="pageLoading" />
  </div>
  <template v-else>
    <div
      v-if="loading"
      class="flex justify-center items-center justify-items-center h-screen absolute w-screen z-[99999] bg-white bg-opacity-80"
    >
      <UISpin :show="true" />
    </div>
    <div>
      <div class="flex w-full preview-area relative">
        <div class="flex w-full">
          <PagesLoop
            class="flex flex-col items-center overflow-auto elements_page_parent flex-1 bg-gray-100 pb-8"
          />
        </div>
      </div>
    </div>
  </template>
</template>

<style scoped lang="scss">
.preview-area {
  height: 100vh;
}

.elements_page_parent {
  padding-top: 1rem;
  margin-bottom: 1rem;
}
</style>
